(function () {
  'use strict';

  if (window.BNFeatureBenefits && window.BNFeatureBenefits.version === '2.1.0') {
    window.BNFeatureBenefits.scan(document);
    return;
  }

  var instances = new WeakMap();

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function init(root) {
    if (!root || instances.has(root)) return;

    var track = root.querySelector('[data-bnfb-track]');
    var viewport = root.querySelector('[data-bnfb-viewport]');
    var cards = track ? Array.prototype.slice.call(track.querySelectorAll('[data-bnfb-card]')) : [];
    if (!track || !viewport || !cards.length) return;

    var controller = new AbortController();
    var signal = controller.signal;
    var controls = root.querySelector('[data-bnfb-controls]');
    var prevButton = root.querySelector('[data-bnfb-prev]');
    var nextButton = root.querySelector('[data-bnfb-next]');
    var status = root.querySelector('[data-bnfb-status]');
    var currentNode = root.querySelector('[data-bnfb-current]');
    var totalNode = root.querySelector('[data-bnfb-total]');
    var progressNode = root.querySelector('[data-bnfb-progress]');
    var labelNode = root.querySelector('[data-bnfb-label]');
    var reducedQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    var state = {
      page: 0,
      mode: '',
      timer: 0,
      delayTimer: 0,
      resizeTimer: 0,
      touchX: 0,
      touchY: 0,
      inView: true,
      observer: null,
      resizeObserver: null,
      interactionTimers: new WeakMap()
    };

    instances.set(root, { destroy: destroy, state: state });

    function mode() {
      var width = window.innerWidth || document.documentElement.clientWidth;
      if (width < 750) return 'mobile';
      if (width < 990) return 'tablet';
      return 'desktop';
    }

    function visibleCount() {
      if (state.mode === 'mobile') return 1;
      if (state.mode === 'tablet') return Math.min(2, cards.length);
      return Math.max(2, Math.min(3, Number(root.dataset.bnfbDesktopVisible || 3), cards.length));
    }

    function pageCount() {
      return Math.max(1, Math.ceil(cards.length / visibleCount()));
    }

    function startIndex() {
      if (state.mode === 'mobile') return state.page;
      var visible = visibleCount();
      return Math.min(state.page * visible, Math.max(0, cards.length - visible));
    }

    function setInteractive(card, isVisible) {
      card.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      if ('inert' in card) card.inert = !isVisible;
      var links = card.querySelectorAll('a, button, input, select, textarea, [tabindex]');
      Array.prototype.forEach.call(links, function (node) {
        if (!('inert' in card)) {
          if (!isVisible) {
            if (!node.hasAttribute('data-bnfb-tabindex')) node.setAttribute('data-bnfb-tabindex', node.getAttribute('tabindex') || '');
            node.setAttribute('tabindex', '-1');
          } else if (node.hasAttribute('data-bnfb-tabindex')) {
            var oldValue = node.getAttribute('data-bnfb-tabindex');
            if (oldValue === '') node.removeAttribute('tabindex'); else node.setAttribute('tabindex', oldValue);
            node.removeAttribute('data-bnfb-tabindex');
          }
        }
      });
    }

    function mobileRelative(index) {
      var total = cards.length;
      var forward = (index - state.page + total) % total;
      var backward = (state.page - index + total) % total;
      if (forward === 0) return 'active';
      if (forward === 1) return 'next';
      if (backward === 1) return 'prev';
      return 'hidden';
    }

    function syncMobileHeight() {
      if (state.mode !== 'mobile') {
        track.style.height = '';
        return;
      }
      window.requestAnimationFrame(function () {
        var active = cards[state.page];
        if (active) track.style.height = Math.ceil(active.offsetHeight) + 'px';
      });
    }

    function controlsConfig() {
      var arrows = state.mode === 'mobile' ? root.dataset.bnfbMobileArrows === 'true' : root.dataset.bnfbDesktopArrows === 'true';
      var showStatus = state.mode === 'mobile' ? root.dataset.bnfbMobileStatus === 'true' : root.dataset.bnfbDesktopStatus === 'true';
      return { arrows: arrows, status: showStatus };
    }

    function renderControls() {
      if (!controls) return;
      var pages = pageCount();
      var cfg = controlsConfig();
      var useful = pages > 1 && (cfg.arrows || cfg.status);
      controls.hidden = !useful;
      root.classList.toggle('bnfb--arrows-hidden', !cfg.arrows);
      root.classList.toggle('bnfb--status-hidden', !cfg.status);
      if (prevButton) prevButton.hidden = !cfg.arrows;
      if (nextButton) nextButton.hidden = !cfg.arrows;
      if (status) status.hidden = !cfg.status;
      if (currentNode) currentNode.textContent = pad(state.page + 1);
      if (totalNode) totalNode.textContent = pad(pages);
      if (progressNode) progressNode.style.width = (((state.page + 1) / pages) * 100) + '%';
      if (labelNode) labelNode.textContent = 'Vista ' + (state.page + 1) + ' de ' + pages;
    }

    function render() {
      var nextMode = mode();
      if (nextMode !== state.mode) {
        state.mode = nextMode;
        state.page = 0;
        root.dataset.bnfbMode = nextMode;
      }

      var pages = pageCount();
      state.page = ((state.page % pages) + pages) % pages;

      if (state.mode === 'mobile') {
        track.style.transform = '';
        cards.forEach(function (card, index) {
          var position = mobileRelative(index);
          card.classList.remove('is-mobile-active', 'is-mobile-next', 'is-mobile-prev', 'is-mobile-hidden');
          card.classList.add('is-mobile-' + position);
          setInteractive(card, position === 'active');
        });
        syncMobileHeight();
      } else {
        track.style.height = '';
        cards.forEach(function (card) {
          card.classList.remove('is-mobile-active', 'is-mobile-next', 'is-mobile-prev', 'is-mobile-hidden');
        });
        var visible = visibleCount();
        var first = startIndex();
        window.requestAnimationFrame(function () {
          var startCard = cards[first];
          track.style.transform = 'translate3d(' + (-(startCard ? startCard.offsetLeft : 0)) + 'px,0,0)';
        });
        cards.forEach(function (card, index) {
          setInteractive(card, index >= first && index < first + visible);
        });
      }

      renderControls();
    }

    function goToPage(index) {
      var pages = pageCount();
      state.page = ((index % pages) + pages) % pages;
      render();
    }

    function next() { goToPage(state.page + 1); }
    function prev() { goToPage(state.page - 1); }

    function goToCard(index) {
      if (state.mode === 'mobile') goToPage(index);
      else goToPage(Math.floor(index / visibleCount()));
    }

    function stopAutoplay() {
      if (state.timer) window.clearInterval(state.timer);
      if (state.delayTimer) window.clearTimeout(state.delayTimer);
      state.timer = 0;
      state.delayTimer = 0;
    }

    function autoplayEnabled() {
      if (state.mode === 'mobile') return root.dataset.bnfbMobileAutoplay === 'true';
      if (state.mode === 'tablet') return root.dataset.bnfbTabletAutoplay === 'true';
      return root.dataset.bnfbDesktopAutoplay === 'true';
    }

    function autoplayDelay() {
      return Math.max(0, Number(state.mode === 'mobile' ? root.dataset.bnfbMobileDelay : root.dataset.bnfbDesktopDelay) || 0);
    }

    function autoplayInterval() {
      return Math.max(1500, Number(state.mode === 'mobile' ? root.dataset.bnfbMobileInterval : root.dataset.bnfbDesktopInterval) || 5000);
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplayEnabled() || pageCount() <= 1 || document.hidden || !state.inView) return;
      state.delayTimer = window.setTimeout(function () {
        next();
        state.timer = window.setInterval(next, autoplayInterval());
      }, autoplayDelay());
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    function interact(card) {
      if (!card || root.dataset.bnfbCardInteraction === 'none') return;
      card.classList.remove('is-interacted');
      void card.offsetWidth;
      card.classList.add('is-interacted');
      var oldTimer = state.interactionTimers.get(card);
      if (oldTimer) window.clearTimeout(oldTimer);
      var timer = window.setTimeout(function () { card.classList.remove('is-interacted'); }, 760);
      state.interactionTimers.set(card, timer);
    }

    function onTouchStart(event) {
      if (state.mode === 'desktop' || !event.touches || !event.touches[0]) return;
      stopAutoplay();
      state.touchX = event.touches[0].clientX;
      state.touchY = event.touches[0].clientY;
    }

    function onTouchEnd(event) {
      if (state.mode === 'desktop' || !event.changedTouches || !event.changedTouches[0]) {
        restartAutoplay();
        return;
      }
      var dx = event.changedTouches[0].clientX - state.touchX;
      var dy = event.changedTouches[0].clientY - state.touchY;
      if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) next(); else prev();
      } else {
        interact(event.target.closest('[data-bnfb-card]'));
      }
      restartAutoplay();
    }

    if (prevButton) prevButton.addEventListener('click', function () { prev(); restartAutoplay(); }, { signal: signal });
    if (nextButton) nextButton.addEventListener('click', function () { next(); restartAutoplay(); }, { signal: signal });
    viewport.addEventListener('touchstart', onTouchStart, { passive: true, signal: signal });
    viewport.addEventListener('touchend', onTouchEnd, { passive: true, signal: signal });
    root.addEventListener('pointerup', function (event) {
      if (event.pointerType === 'touch' || event.pointerType === 'pen') interact(event.target.closest('[data-bnfb-card]'));
    }, { signal: signal });
    root.addEventListener('mouseenter', stopAutoplay, { signal: signal });
    root.addEventListener('mouseleave', startAutoplay, { signal: signal });
    root.addEventListener('focusin', stopAutoplay, { signal: signal });
    root.addEventListener('focusout', function () { window.setTimeout(startAutoplay, 0); }, { signal: signal });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') { event.preventDefault(); next(); restartAutoplay(); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); prev(); restartAutoplay(); }
    }, { signal: signal });

    cards.forEach(function (card) {
      Array.prototype.slice.call(card.querySelectorAll('img')).forEach(function (image) {
        if (!image.complete) image.addEventListener('load', function () { render(); }, { once: true, signal: signal });
      });
    });

    var reducedMotion = Boolean(reducedQuery && reducedQuery.matches);
    root.classList.add('bnfb-motion-armed');
    root.classList.toggle('bnfb-reduced-motion', reducedMotion);

    if ('IntersectionObserver' in window) {
      state.inView = false;
      state.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== root) return;
          state.inView = entry.isIntersecting && entry.intersectionRatio > 0.08;
          root.classList.toggle('bnfb-in-view', state.inView);
          if (state.inView) startAutoplay(); else stopAutoplay();
        });
      }, { threshold: [0, 0.08, 0.3], rootMargin: '0px 0px -8% 0px' });
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { state.observer && state.observer.observe(root); });
      });
    } else {
      requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('bnfb-in-view'); }); });
    }

    if ('ResizeObserver' in window) {
      state.resizeObserver = new ResizeObserver(function () {
        window.clearTimeout(state.resizeTimer);
        state.resizeTimer = window.setTimeout(render, 80);
      });
      state.resizeObserver.observe(root);
    } else {
      window.addEventListener('resize', function () {
        window.clearTimeout(state.resizeTimer);
        state.resizeTimer = window.setTimeout(function () { render(); restartAutoplay(); }, 120);
      }, { signal: signal });
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAutoplay(); else startAutoplay();
    }, { signal: signal });

    document.addEventListener('shopify:block:select', function (event) {
      var card = event.target && event.target.closest ? event.target.closest('[data-bnfb-card]') : null;
      if (!card || !root.contains(card)) return;
      var index = Number(card.dataset.bnfbIndex || 0);
      goToCard(index);
      stopAutoplay();
    }, { signal: signal });

    render();
    startAutoplay();

    function destroy() {
      stopAutoplay();
      window.clearTimeout(state.resizeTimer);
      if (state.observer) state.observer.disconnect();
      if (state.resizeObserver) state.resizeObserver.disconnect();
      controller.abort();
      cards.forEach(function (card) {
        var timer = state.interactionTimers.get(card);
        if (timer) window.clearTimeout(timer);
      });
      instances.delete(root);
    }
  }

  function scan(scope) {
    var base = scope || document;
    var roots = [];
    if (base.matches && base.matches('[data-bnfb-carousel]')) roots.push(base);
    if (base.querySelectorAll) roots = roots.concat(Array.prototype.slice.call(base.querySelectorAll('[data-bnfb-carousel]')));
    roots.forEach(init);
  }

  function unload(scope) {
    if (!scope) return;
    var roots = [];
    if (scope.matches && scope.matches('[data-bnfb-carousel]')) roots.push(scope);
    if (scope.querySelectorAll) roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-bnfb-carousel]')));
    roots.forEach(function (root) {
      var instance = instances.get(root);
      if (instance) instance.destroy();
    });
  }

  window.BNFeatureBenefits = { version: '2.1.0', scan: scan, unload: unload };
  scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { unload(event.target); });
})();
